import React from 'react';
import { motion } from 'framer-motion';
import { GiftIcon } from 'lucide-react';
import { SectionHeading } from './ui/SectionHeading';
import { bonuses } from '../data/bonuses';
import { bonusTotalValue, totalBonuses } from '../data/offer';
export function BonusSection() {
  return <section className="border-y border-cta/40 bg-surface py-16 sm:py-20" aria-labelledby="bonus-title" data-id="element-20" data-mp="1yeb4ckorj8qr">
      <div className="mx-auto max-w-4xl px-4" data-id="element-21" data-mp="1ao7bn8d44tej">
        <SectionHeading id="bonus-title" data-id="element-22" data-mp="1aoyvjlxcl2oz">The {totalBonuses} <span className="text-primary" data-id="element-23" data-mp="15pm932ae1xmx">Exclusive Bonuses</span></SectionHeading>

        <ul className="mt-10 overflow-hidden rounded-2xl border border-cta/50 bg-background shadow-glow" data-id="element-24" data-mp="1jgr41r2ta1qx">
          {bonuses.map((bonus, index) => {
          const Icon = bonus.icon;
          return <motion.li key={bonus.title} initial={{
            opacity: 0,
            y: 12
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true
          }} transition={{
            duration: 0.28,
            delay: index * 0.04,
            ease: [0.23, 1, 0.32, 1]
          }} className="flex gap-4 border-b border-primary/20 p-5 last:border-b-0 sm:p-6" data-id="element-25" data-mp="1eo7r8wby7an6" data-mpi={index}>
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-lg bg-cta text-cta-foreground shadow-glow-cta" data-id="element-26" data-mp="2jhcvcwn4vc0c">
                  <Icon className="h-5 w-5" aria-hidden="true" data-id="element-27" data-mp="2ogg2cmmobsay" />
                </span>
                <div data-id="element-28" data-mp="1quim6vvrnz26">
                  <p className="text-xs font-bold uppercase tracking-[.14em] text-primary" data-id="element-29" data-mp="1qv1xhtqwvp78">Bonus {bonus.number}</p>
                  <h3 className="mt-1 text-lg font-bold leading-tight text-foreground" data-id="element-30" data-mp="1vu5077jf5jc1">{bonus.title}</h3>
                  <p className="mt-1.5 text-sm leading-relaxed text-muted" data-id="element-31" data-mp="25qht43753t5q">{bonus.description}</p>
                </div>
              </motion.li>;
        })}
        </ul>

        <div className="mt-6 flex flex-col items-center justify-between gap-5 rounded-2xl border-2 border-cta bg-background px-6 py-6 text-center shadow-glow-cta sm:flex-row sm:text-left" data-id="element-32" data-mp="3c621ja31q7iy">
          <div data-id="element-33" data-mp="1h240zw2hudhp">
            <p className="text-xs font-bold uppercase tracking-[.16em] text-muted" data-id="element-34" data-mp="1h1kh49ta9f11">Value of all {totalBonuses} bonuses</p>
            <p className="mt-1 text-3xl font-bold tracking-tight text-muted line-through decoration-primary decoration-2" data-id="element-35" data-mp="1q43fohq1d5hh">
              {bonusTotalValue}
            </p>
          </div>
          <div className="sm:text-right" data-id="element-36" data-mp="1m0drhtd9wpwz">
            <p className="text-xs font-bold uppercase tracking-[.16em] text-muted" data-id="element-37" data-mp="yc4d3cie34fv">Your price today</p>
            <p className="mt-2 inline-flex items-center gap-2 rounded-xl bg-cta px-4 py-1.5 text-3xl font-extrabold tracking-tight text-cta-foreground" data-id="element-38" data-mp="tem27gktaf58">
              <GiftIcon className="h-6 w-6" aria-hidden="true" data-id="element-39" data-mp="17728qrcx8vaw" /> FREE
            </p>
          </div>
        </div>
      </div>
    </section>;
}